import React, {useMemo} from "react";
import {AppPath} from "../../../Router/AppRouter.jsx";
import {PageLayout} from "../../../components/layout/Page/PageLayout.jsx";

export const ShowcaseLayout = ({children, showNav = true, ...otherProps}) => {

    const navLinks = useMemo(() => [
        { title: "Test Data Grid", path: AppPath.testDataGrid },
        { title: "Test Form", path: AppPath.testForm },
        { title: "Test Dialogs", path: AppPath.testDialogs },
    ], []);

    return (
        <PageLayout navPosition={"top"} navLinks={navLinks} showNav={showNav}>
            {children}
        </PageLayout>
    );
}